import React from "react";
import TopStoryCard from "../../top-story-card/TopStoryCard";
import Chart, { formatChartDate, formatTableDate, getLastPublishedTimeGoldForex } from "../../../../atoms/Chart";
import HistoricalGoldRateTable from "./HistoricalGoldRateTable";

const GCCHistoricalRates = ({ historicalRate, country, currency }) => {
  const lineKeys = ["carat24", "carat22", "carat21", "carat18"];
  const xAxisKey = "date";
  const domin = ["dataMin-4", "dataMax+4"];
  const lineNames = ["24ct", "22ct", "21ct", "18ct"];
  const currentDate = formatTableDate();

  const formattedChartData = historicalRate
    ?.map((item) => ({
      date: formatChartDate(item?.date),
      carat24: item?.carat24,
      carat22: item?.carat22,
      carat21: item?.carat21,
      carat18: item?.carat18,
    }))
    ?.reverse();

  return (
    <div>
      <TopStoryCard
        heading={`${country} Historical Gold Rate Chart (${currency}/g)`}
        date={currentDate}
        updatedAt={getLastPublishedTimeGoldForex(historicalRate?.[0]?.lastUpdated)}
        id="gold-rates-002"
      />
      <Chart
        data={formattedChartData}
        xAxisKey={xAxisKey}
        domin={domin}
        lineKeys={lineKeys}
        lineNames={lineNames}
        dataKey={lineKeys}
      />
      <HistoricalGoldRateTable historicalRate={historicalRate} />
    </div>
  );
};

export default GCCHistoricalRates;
